import http from "./axios";

export default {
  async getAboutUs() {
    try {
      const { data:aboutus } = await http.get(`/api/about_incocegla`);
      return aboutus.data;
    } catch (error) {
        throw error.response || error;
    }
  },
  async getGlaucomaClub() {
    try {
      const { data:clubs } = await http.get(`/api/clubs`);
      return clubs.data;
    } catch (error) {
        throw error.response || error;
    }
  },
  async getInstallations() {
    try {
      const { data:installations } = await http.get(`/api/installations`);
      return installations.data;
    } catch (error) {
        throw error.response || error;
    }
  },
  async getFoundation() {
    try {
      const { data:foundation } = await http.get(`/api/foundations`);
      return foundation.data;
    } catch (error) {
        throw error.response || error;
    }
  },
  async getFoundationProjects() {
    try {
      const { data:projects } = await http.get(`/api/proyects`);
      return projects.data;
    } catch (error) {
        throw error.response || error;
    }
  },
  async general() {
    try {
      const { data:general } = await http.get(`/api/general`);
      return general.data;
    } catch (error) {
        throw error.response || error;
    }
  },
};
